export const environment = {
  logAppId: 'dev.magicappui',
  loggerUrl: 'https://b2bapplog.ascent24.io/dev.magicappui',
  production: false,
  version: '0.0.14',
  apiUrl: 'https://magicapp-stageapi.ascent24.io/',
  paymentRedirectUrl: 'https://wov-payment.ascent24.io/payment',
  orgId: 'd1237546-51f4-11ee-b16a-ff05701754db',
};
